import React from 'react';
import { View, ActivityIndicator, Pressable } from 'react-native';
import styled from 'styled-components/native';

import { Text } from 'app/src/styles';
import colors from 'app/src/styles/colors';
import fonts from 'app/src/styles/fonts';

const CONTAINER_STYLES = `
  flex-direction: row;
  justify-content: center;
  gap: 10px;
  background-color: ${colors.button};
  width: 200px;
  padding-vertical: 12px;
  padding-horizontal: 20px;
  border-radius: 4px;
  align-items: center;
  margin-top: 12px;
  margin-bottom: 12px;
`;

const Container = styled(View)`
  ${CONTAINER_STYLES}
`;

const PressableContainer = styled(Pressable)`
  ${CONTAINER_STYLES}
  background-color: ${props => props.disabled ? colors.border : colors.button};
  opacity: ${props => props.disabled ? 0.6 : 1};
`;

const ButtonText = styled(Text)`
  font-family: ${fonts.body};
  font-size: 16px;
  color: ${colors.textOnDark};
  font-weight: 600;
  text-decoration-line: none;
  text-align: center;
  letter-spacing: 0.3px;
`;

export const ButtonGroup = styled(View)`
  flex-direction: row;
  gap: 12px;
`;

export const Button = allProps => {
  const { to, label, dangerous, inline, wide, processing, secondary, ...props } = allProps;

  props.style ||= {};
  const textStyle = {};

  if ('Cancel' === props.type) {
    props.style.backgroundColor = 'transparent';
    props.style.borderWidth = 1;
    props.style.borderColor = colors.buttonSecondary;
    textStyle.color = colors.buttonSecondary;
    props.label ||= 'Cancel';
  } else if (secondary) {
    // Secondary buttons: transparent with border
    props.style.backgroundColor = 'transparent';
    props.style.borderWidth = 1;
    props.style.borderColor = colors.buttonSecondary;
    textStyle.color = colors.buttonSecondary;
  } else if (dangerous) {
    props.style.backgroundColor = colors.danger;
  }

  if (inline) {
    props.style.marginTop = 0;
    props.style.marginBottom = 0;
    props.style.paddingVertical = 8;
    props.style.paddingHorizontal = 16;
    textStyle.fontSize = 14;
  }

  if (wide) {
    props.style.width = '100%';
  }

  if (processing) {
    props.disabled = true;
  }

  const content = (
    <>
      <ButtonText style={textStyle}>{label || props.label}</ButtonText>
      {processing && <ActivityIndicator size="small" color={colors.textOnDark} />}
    </>
  );

  return <PressableContainer {...props}>{content}</PressableContainer>;
}
